import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_64: FaireProductEntity = {
  token: "catalog_prod_prod-64",
  type: "product",
  name: "Stone Coasters - Set of 4 - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 48.15,
  msrpDollars: 120.38,
  sku: "JA0064",
  caseSize: 4,
  material: "Wood",
  collectionToken: "col_japandi",
  categoryTokens: ["catalog_cat_dogs"],
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 380,
  description: "Beautiful Japandi piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
